import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
declare let voxAPI: any;
declare let VoxImplant: any;
declare let currentCall: any;
export class VoximplantCallBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('voximplant-call');
    }

    private static OnConnected(): void {
        $.ajax('/SimpleIdentification/GetVoximplantCredentials', {
            success: function (data) {
                {
                    voxAPI.login(data.login, data.password);
                }
            },
        });
    }

    public static initApi() {
        voxAPI = VoxImplant.getInstance();

        voxAPI.on(
            VoxImplant.Events.SDKReady,
            VoximplantCallBehaviour.OnSdkReady
        );
        voxAPI.on(
            VoxImplant.Events.ConnectionEstablished,
            VoximplantCallBehaviour.OnConnected
        );
        voxAPI.on(VoxImplant.Events.AuthResult, VoximplantCallBehaviour.OnAuth);

        if (!voxAPI.alreadyInitialized) {
            $.ajax('/SimpleIdentification/GetVoximplantSettings', {
                success: function (data) {
                    {
                        voxAPI.init({
                            localVideoContainerId: 'voximplant_container',
                            showDebugInfo: data.showDebugInfo,
                        });
                    }
                },
            });
        } else VoximplantCallBehaviour.OnSdkReady();
    }

    private static UpdateFPS() {
        $.ajax('/SimpleIdentification/GetVoximplantSettings', {
            success: function (data) {
                const sender =
                    currentCall.peerConnection.impl.getTransceivers()[1].sender;

                const parameters = sender.getParameters();

                delete parameters.encodings[0].maxBitrate;

                parameters.encodings[0].maxFramerate = data.callFps;

                sender.setParameters(parameters);
            },
        });
    }

    private static Call(): void {
        $('#voximplantDataForm').validate();

        if ($('#voximplantDataForm').valid()) {
            $.ajax('/SimpleIdentification/GetAccountCustomCallData', {
                success: function (receivedData) {
                    const formData = Ajax.serializeObject(
                        $('#voximplantDataForm')
                    );

                    $.ajax('/account/profile/edit/voximplantcallback', {
                        data: formData,
                        method: 'post',
                        success: function (result) {
                            $.extend(formData, receivedData);

                            const callSettings = {
                                num: receivedData.callCenterNumber,
                                useVideo: {
                                    sendVideo: true,
                                },
                                customData: formData,
                            };

                            currentCall = voxAPI.call(
                                receivedData.callCenterNumber,
                                {
                                    sendVideo: true,
                                    receiveVideo: true,
                                },
                                formData,
                                {}
                            );

                            currentCall.addEventListener(
                                VoxImplant.CallEvents.Connected,
                                VoximplantCallBehaviour.OnCallConnected
                            );
                            currentCall.addEventListener(
                                VoxImplant.CallEvents.Disconnected,
                                VoximplantCallBehaviour.OnCallDiconnected
                            );
                            currentCall.addEventListener(
                                VoxImplant.CallEvents.Failed,
                                VoximplantCallBehaviour.OnCallFailed
                            );

                            $('#callButton').hide();
                            $('#endCallButton').show();
                            $('#voximplantDataForm').hide();
                        },
                    });
                },
            });
        }
    }

    private static OnCallFailed() {
        $.ajax('/account/profile/edit/voximplantfailcallback', {
            success: function () {
                VoxImplant.Hardware.StreamManager.get().hideLocalVideo();
                $('.btn-group').hide();
                $('#voximplantDataForm').hide();
                $('.voximplant_container_common').html(
                    '<div><div class="profile-ident-popup__result"><span class="profile-ident__ident-error"></span><div class="profile-ident__popup-text"><p class="profile-ident-popup__result-title">' +
                        window.Localization.getString(
                            'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_4',
                            'Ошибка при звонке'
                        ) +
                        '</p><p class="profile-ident-popup__result-text">' +
                        window.Localization.getString(
                            'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_5',
                            'Попробуйте еще раз или выберите другой способ идентификации'
                        ) +
                        '</p></div></div><div class="profile-ident-popup__box-button m-passport"><a class="button profile-ident-popup__button m-grey" onclick="Popup.Close(this)">' +
                        window.Localization.getString(
                            'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_6',
                            'ЗАКРЫТЬ'
                        ) +
                        '</a></div></div>'
                );
            },
        });
    }

    private static OnCallConnected() {
        VoximplantCallBehaviour.UpdateFPS();
        VoximplantCallBehaviour.sendVideo(true);
        VoximplantCallBehaviour.showRemoteVideo(true);
    }

    private static OnCallDiconnected(call, headers) {
        $('.btn-group').hide();
        $('#voximplantDataForm').hide();
        VoxImplant.Hardware.StreamManager.get().hideLocalVideo();
        $('.voximplant_container_common').html(
            '<div><div class="profile-ident-popup__result"><span class="profile-ident__ident-icon"></span><div class="profile-ident__popup-text"><p class="profile-ident-popup__result-title">' +
                window.Localization.getString(
                    'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_7',
                    'Проводится идентификация!'
                ) +
                '</p><p class="profile-ident-popup__result-text">' +
                window.Localization.getString(
                    'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_8',
                    'Это может занять определенное время'
                ) +
                '</p></div></div><div class="ident-popup__footer"><a class="button profile-ident-popup__button m-grey" onclick="Popup.Close(this); window.location.reload();">' +
                window.Localization.getString(
                    'Scripts_Shared_Infrastructure.VoximplantCallBehaviour_6',
                    'ЗАКРЫТЬ'
                ) +
                '</a></div></div>'
        );
        voxAPI.disconnect();
    }

    private static OnSdkReady(): void {
        voxAPI.connect();
    }

    private static OnAuth(e): void {
        $('.btn-group').show();
        $('#voximplantDataForm').show();
        $('#voximplantSpinner').hide();

        VoxImplant.Hardware.CameraManager.get()
            .getInputDevices()
            .then(function (result) {
                const select = document.getElementById('camerasUser');

                for (let i = 0; i < result.length; i++) {
                    const opt = document.createElement('option');

                    opt.value = result[i].id;
                    opt.innerHTML = result[i].name;

                    select.appendChild(opt);
                }
            }, null);

        VoxImplant.Hardware.StreamManager.get().showLocalVideo(true);

        $.ajax('/SimpleIdentification/GetVoximplantVideoResolution', {
            success: function (result) {
                VoxImplant.Hardware.CameraManager.get().setDefaultVideoSettings(
                    {
                        frameHeight: result.frameHeight,
                        frameWidth: result.frameWidth,
                    }
                );
            },
        });
    }

    private static showRemoteVideo(flag) {
        currentCall.showRemoteVideo(flag);
    }

    private static sendVideo(flag) {
        currentCall.sendVideo(flag);
    }

    public static EndWork() {
        window.location.reload();
    }

    public static HangupCall() {
        if (typeof currentCall !== 'undefined') currentCall.hangup();

        $('#endCallButton').hide();
    }

    protected installBehaviour(element: HTMLElement): void {
        $(element).click(function () {
            VoximplantCallBehaviour.Call();
        });

        $('#endCallButton').click(function () {
            VoximplantCallBehaviour.HangupCall();
        });

        $('#camerasUser').change(function () {
            $.ajax('/SimpleIdentification/GetVoximplantVideoResolution', {
                success: function (result) {
                    const selectedCam = $('#camerasUser').val();

                    VoxImplant.Hardware.StreamManager.get().hideLocalVideo();

                    VoxImplant.Hardware.CameraManager.get().setDefaultVideoSettings(
                        {
                            frameHeight: result.frameHeight,
                            frameWidth: result.frameWidth,
                            cameraId: selectedCam,
                        }
                    );

                    if (typeof currentCall !== 'undefined') {
                        VoxImplant.Hardware.CameraManager.get().setCallVideoSettings(
                            currentCall,
                            {
                                frameHeight: result.frameHeight,
                                frameWidth: result.frameWidth,
                                cameraId: selectedCam,
                            }
                        );

                        VoximplantCallBehaviour.UpdateFPS();
                    }

                    VoxImplant.Hardware.StreamManager.get().showLocalVideo(
                        true
                    );
                },
            });
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.VoximplantCallBehaviour = VoximplantCallBehaviour;